// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pFHkb","badges":"styles_badges__3xV3U"};